import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueCarousel from 'vue-carousel'
Vue.use(VueCarousel)
import VueMask from 'v-mask'
Vue.use(VueMask)
import VueGtm from '@gtm-support/vue2-gtm'

Vue.use(VueGtm, {
    id: 'GTM-M9X7VSQ',
    vueRouter: router
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
